// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__30G_q","title":"Images45_title__2CIVa","images":"Images45_images__Vv7d2"};